// src/misc/america250/organizerLinks.js

/**
 * Map of organizer display name -> website URL
 * Keys must match the sheet "Organizer" values exactly.
 */
export const ORGANIZER_LINKS = {
  "Senior Services/YFS":
    "https://www.glastonburyct.gov/departments/department-directory-a-h/human-services/senior-services#ad-image-0",

  "Senior Services":
    "https://www.glastonburyct.gov/departments/department-directory-a-h/human-services/senior-services#ad-image-0",

  "MLK Community Initiative":
    "https://glastonburymlkci.org/",

  "T.A.L.K":
    "https://talk-action.org/",

  "Welles-Turner Memorial Library":
    "https://www.wtmlib.info/",
};